<template>
    <div>
        <div class="d-flex justify-content-between align-items-center row">
            <div class="col-sm-12 col-md-6">
                <slot name="withPerPage"></slot>
            </div>
            <div class="mb-2 text-right">
                <slot name="withSearch"></slot>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th v-for="(header, key) in headers" :key="key">{{ header.title }}</th>
                </tr>
                </thead>
                <tbody>
                <!--
                <div v-if="loading" class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">{{ customizeData.labelLoading }}</span>
                    </div>
                </div>
                -->
                <slot name="withBody"></slot>
                </tbody>
            </table>
            <div class="footer__section">
                <div class="prev__section">
                    <div role="status" aria-live="polite">{{ customizeData.labelDetails }}</div>
                </div>
                <div class="next__section">
                    <slot name="withPagination"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    const default_customize = {
        labelShowing: 'Show',
        labelEntries: 'entries',
        entries: [10, 15, 20, 25, 30],
        labelSearch: 'Search',
        labelLoading: 'Loading...',
        labelDetails: 'Showing 0 to 0 of 0 entries'
    };
    export default {
        name: "dataTable",
        props:{
            headers: {
                type: Array,
                default: () => []
            },
            data: {
                type: Array,
                default: () => [],
            },
            customizeTable:{
                type: Object,
                default: () => {}
            },
            loading:{
                type: Boolean,
                default: () => false
            }
        },
        data: () => ({
            items: [],
            customizeData: {},
            search: '',
        }),
        created() {
            this.items = this.data;
            if (Object.keys(this.customizeTable).length === 0){
                this.customizeData = default_customize
            }else this.customizeData = this.customizeTable;
        },
        methods:{
            getTest(el){ console.log(el) }
        }
    }
</script>

<style scoped lang="scss">
    .footer__section{
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-content: center;
        align-items: center;
        .next__section {
            justify-self: end;
        }
    }
</style>
